import {joinWithCommasAndAnd} from "./miscUtils";
import { t } from "@lingui/core/macro";
import { i18n } from "@lingui/core";

export function getTravelTileText(status, isOpen, hasPassed, isMedicalandMobilityOpted, medicalandMobilityStatus, passportStatus, passportIsOpen, travelinfoOpenCutOff) {
    if(hasPassed) {
        return status === "COMPLETE" ?
            `${t({id: "complete"})}.` :
            t({id: "travel_tile_passed_not_complete_text"});
    }

    if(isOpen) {
        let missingFields = [];

        if (isMedicalandMobilityOpted && medicalandMobilityStatus !== "COMPLETE") {
            missingFields.push(t({id: "medical_and_mobility_information_field"}))
        }

        if (passportIsOpen && passportStatus !== "COMPLETE") {
            missingFields.push(t({id: "passport_information_field"}));
        }

        if(missingFields.length > 0){
            return lockedMessageWithMissingFields(missingFields);
        }

        return status === "COMPLETE" ?
            t({id: "complete_update_until_departure_text"}) :
            t({id: "submit_your_travel_information"});
    }

    return getAvailableBeforeCruise(travelinfoOpenCutOff);
}

export function getMedicalAndMobilityTileText(status, isOpen, hasPassed, medicalMobilityOpenCutOff){
    if(hasPassed) {
        return status === "COMPLETE" ?
            t({id:"m_and_m_completed_and_locked_text"}) :
            t({id:"m_and_m_closed_text"});
    }

    if(isOpen) {
        return (
            status === "COMPLETE" ? 
                t({id: "complete_can_be_updated_14_days_departure"}) : 
                t({id:"add_m_and_m_here_text"})
        )
    }

    return getAvailableBeforeCruise(medicalMobilityOpenCutOff);
}

export function getPassportInformationTileText(status, isOpen, hasPassed, isMedicalandMobilityOpted, medicalandMobilityStatus, passportOpenCutOff) {
    if(hasPassed) {
        return status === "COMPLETE" ?
            t({id:"passport_info_completed_and_locked_text"}) :
            t({id:"passport_info_closed_text"});
    }

    if(isOpen) {
        if (isMedicalandMobilityOpted && medicalandMobilityStatus !== "COMPLETE") {
            return t({id:"locked_because_m_and_m_text"});
        }
        return status === "COMPLETE" ? `${t({id: "complete"})}.` : t({id:"add_your_passport_information_here"});
    }

    return getAvailableBeforeCruise(passportOpenCutOff);
}

export function getCovidTileText(status, isOpen, hasPassed, covidPositive, passportStatus, passportIsOpen, covidOpenCutOff) {
    if(covidPositive) {
        return t({id: "please_call_the_contact_centre"});
    }

    if(hasPassed) {
        return status === "COMPLETE" ?
            t({id:"health_survey_completed_and_locked_text"}) :
            t({id:"health_survey_closed_text"});
    }

    if(isOpen) {
        if (passportIsOpen && passportStatus !== "COMPLETE") {
            return t({id:"locked_because_passport_text"});
        }

        return status === "COMPLETE" ?
            `${t({id: "complete"})}.` :
            t({id:"complete_this_survey_before_travel"});
    }


    return getAvailableBeforeCruise(covidOpenCutOff);
}


export function getImmigrationTileText(status, isOpen, hasPassed, covidPositive, passportStatus, passportIsOpen, immigrationOpenCutOff) {
    if(covidPositive) {
        return t({id: "please_call_the_contact_centre"});
    }

    if(hasPassed) {
        return status === "COMPLETE" ?
            t({id:"immigration_completed_and_locked_text"}) :
            t({id:"immigration_closed_text"});
    }

    if(isOpen) {
        if (passportIsOpen && passportStatus !== "COMPLETE") {
            return t({id:"locked_because_passport_text"});
        }

        return status === "COMPLETE" ?
            `${t({id: "complete"})}.` :
            t({id:"complete_this_before_travel_text"});
    }


    return getAvailableBeforeCruise(immigrationOpenCutOff);
}

export function getBoardingTileText(preTravelStatus, covidStatus, cardRegistrationStatus, isMedicalandMobilityOpted, medicalandMobilityStatus, apiStatus, immigrationApplicable, immigrationStatus, covidPositive, isOpen, hasCovidPassed) {
    if(covidPositive) {
        return t({id: "please_call_the_contact_centre"});
    }

    let meetsConditions = true;
    const missingFields = [];

    if (isMedicalandMobilityOpted && medicalandMobilityStatus !== "COMPLETE" && medicalandMobilityStatus!=="DISABLED") {
        meetsConditions = false;
        missingFields.push(t({id: "medical_and_mobility_information_field"}));
    }

    if(apiStatus !== "DISABLED" && apiStatus !== "COMPLETE") {
        meetsConditions = false;
        missingFields.push(t({id: "passport_information_field"}));
    }

    if(preTravelStatus !== "DISABLED" && preTravelStatus !== "COMPLETE") {
        meetsConditions = false;
        missingFields.push(t({id: "travel_information_field"}));
    }

    if(covidStatus !== "DISABLED" && covidStatus !== "COMPLETE") {
        meetsConditions = false;
        missingFields.push(t({id: "health_survey_field"}));
    }

    if(cardRegistrationStatus !== "DISABLED" && cardRegistrationStatus !== "COMPLETE") {
        meetsConditions = false;
        missingFields.push(t({id: "card_registration_field"}));
    }

    if (immigrationApplicable && immigrationStatus !== "COMPLETE" && immigrationStatus !=="DISABLED") {
        meetsConditions = false;
        missingFields.push(t({id: "immigration_check"}));
    }

    if(hasCovidPassed) {
        return meetsConditions ? t({id: "boaring_passes_are_ready"}) : t({id: "please_check_in_at_port_text"});
    }

    if(isOpen) {
        if(meetsConditions) {
            return t({id: "boaring_passes_are_ready"});
        }
        else {
            return lockedMessageWithMissingFields(missingFields);
        }
    }

    return lockedMessageWithMissingFields(missingFields);
}


export function getCCTileText(cardStatus, isOpen, hasPassed, passportStatus, passportIsOpen, cardRegistrationOpenCutOff) {
    if(hasPassed) {
        return t({id:"cc_closed_text"});
    }

    if(isOpen) {
        if (passportIsOpen && passportStatus !== "COMPLETE") {
            return t({id:"locked_because_passport_text"});
        }

        return cardStatus === "COMPLETE" ? `${t({id: "complete"})}.` : t({id:"complete_this_before_travel_text"});
    }

    return getAvailableBeforeCruise(cardRegistrationOpenCutOff);
}

export function getLuggageTileText(isOpen, hasPassed, passportStatus, passportIsOpen, luggageTagsDownloadOpenCutOff) {
    if(hasPassed) {
        return t({id:"luggage_tags_closed_text"});
    }

    if(isOpen) {
        if (passportIsOpen && passportStatus !== "COMPLETE") {
            return t({id:"locked_because_passport_text"});
        }

        return t({id:"your_luggage_labels_are_ready"});
    }

    return getAvailableBeforeCruise(luggageTagsDownloadOpenCutOff);
}


export function getAvailableBeforeCruise(nrDays) {
    if(!nrDays) return t({id: "locked"});

    return i18n._({ 
        id: "available_before_cruise_text",
        message: `Available {nrDays, plural, one {# day} other {# days} } before departure.`,
        values: { nrDays }
    });
}

function lockedMessageWithMissingFields(missingFields){
    return i18n._({
        id: "locked_message_with_missing_fields",
        message: `Locked. Please complete your {fields}.`,
        values: { fields: joinWithCommasAndAnd(missingFields) }
    })
}